module.exports = __webpack_public_path__ + "img/guide.28ab49bd.jpg";